import Image from "next/image";
import FeatureItem from "./FeatureItem";


type Props = {
  image: string;
  iconSrc: string;
  title: string;
  text: string;
  ctaLabel: string;
  ctaLink: string;
};

export default function FinancialAidCard({
  image,
  iconSrc,
  title,
  text,
  ctaLabel,
  ctaLink,
}: Props) {
  return (
    <div className="relative flex flex-col items-center justify-center">
      {/* Image avec coins arrondis */}
      <div className="w-full h-full overflow-hidden rounded-xl">
        <Image src={image} alt={title} width={500} height={600} />
      </div>

      {/* Carte verte superposée */}
      <div className="mt-[-200px] md:mt-0
          md:absolute md:top-[50%] md:left-1/2 md:transform md:-translate-x-1/2
          z-10 w-full md:w-80 max-w-[320px] 
          bg-primaryGreen rounded-3xl border-[12px] border-white
          shadow-lg
          transition-all duration-300">
        <FeatureItem
          iconSrc={iconSrc}
          title={title}
          text={text}
          className="text-white pt-8 px-2 lg:px-4"
          titleClassName="text-white text-lg font-bold"
          ctaLabel={ctaLabel}
          ctaLink={ctaLink}
        />
      </div>
    </div>
  );
}
